import { executeRequest, JFSRequest } from '@jfs/network'
import { RootStore } from '../data/store'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  const data = isSuccessResponse(response)
  console.log('program data =', data)

  return data?.programCategories
}

const getEntityProgramList = (req: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.getProgramDetailsByProgramIds),
    method: 'POST',
    config: sitConfig(RootStore.session.getTokens),
    body: req,
    headers: getHeaders(),
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { getEntityProgramList }
